import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

function buildTooltipTitle(helpText, howToUse) {
  if (!helpText && !howToUse) return null;
  if (!howToUse) return helpText;
  if (!helpText) return howToUse;
  return (
    <div className="field-guide-label__tooltip">
      <div>{helpText}</div>
      <div className="field-guide-label__tooltip-how">{howToUse}</div>
    </div>
  );
}

export default function FieldGuideLabel({
  label,
  helpText,
  howToUse,
  description,
  primary = false,
  deprecated = false,
  className = '',
}) {
  const tooltip = buildTooltipTitle(helpText, howToUse);

  const labelClass = [
    'field-guide-label',
    primary ? 'field-guide-label--primary' : '',
    deprecated ? 'field-guide-label--deprecated' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (!tooltip) {
    return <span className={labelClass}>{label}</span>;
  }

  return (
    <Tooltip title={tooltip}>
      <span className={labelClass}>
        {label}
        <InfoCircleOutlined className="field-guide-label__icon" aria-hidden />
      </span>
    </Tooltip>
  );
}
